import { Link } from "react-router-dom";
import styled from 'styled-components';
import { TextField, IconButton } from '@mui/material';

// These styled-components must be exactly the same as in InferPage
export const InferJobsContainer = styled.div`
  height: calc(100dvh - 70px);
  flex-basis: 300px;
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  background: #180d23;
  padding-top: 20px;
  overflow-y: auto;
  @media only screen and (max-width: 600px) {
    padding-top: 0px;
    flex-basis: calc(100dvh - 70px);
    border-radius: 20px 20px var(--none, 0px) var(--none, 0px);
  }
`;
export const InferJobsHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  padding: 20px 50px;
  @media only screen and (max-width: 600px) {
    padding: 20px;
  }
`;
export const InferJobsHeaderTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  h5 {
    text-align: center;
  }
`;
export const UpgradeLink = styled(Link)`
  margin-bottom: 10px !important;
  color: var(--primary-main, #ff74e9);
  font-family: Raleway;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.15px;
`;
export const InferenceCreditsCount = styled.div`
  margin-top: 5px;
  color: #f5e1ffbd;
  font-family: Raleway;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.15px;
`;
export const SearchContainer = styled.div`
  padding: 0 50px;
  margin-bottom: 30px;
  height: 40px;
  @media only screen and (max-width: 600px) {
    padding: 0 20px;
  }
`;
export const FixedCollapseHistoryButton = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
`;
export const FixedHistoryFooterMobile = styled.div`
  position: sticky;
  bottom: 0px;
  right: 0px;
  left: 0px;
  border-radius: 20px 20px var(--none, 0px) var(--none, 0px);
  background: var(--background-paper-elevation-1, #251a30);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  z-index: 1000;
`;
export const FixedHistoryFooterContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
`;
export const FixedHistoryFooterTitle = styled.div`
  color: var(--text-primary, #fff);
  font-feature-settings: 'liga' off, 'clig' off;
  font-family: Raleway;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 100%;
  letter-spacing: 0.15px;
`;

// TabsBar and TabButton styles (horizontal pill tabs)
export const TabsBar = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  padding: 0 50px 16px 50px;
  width: 100%;
  overflow-x: auto;
  white-space: nowrap;
  scrollbar-width: thin;
  scrollbar-color: #a24bcf #251a30;
  &::-webkit-scrollbar {
    height: 6px;
    background: #251a30;
  }
  &::-webkit-scrollbar-thumb {
    background: #a24bcf;
    border-radius: 3px;
  }
  @media only screen and (max-width: 600px) {
    gap: 4px;
    padding: 0 6px 12px 6px;
  }
`;
export const TabButton = styled.button<{ selected: boolean; disabled?: boolean }>`
  flex: 0 0 auto;
  min-width: 0;
  border: none;
  outline: none;
  border-radius: 26px;
  padding: 8px 22px;
  font-family: Raleway;
  font-size: 13px;
  font-weight: 500;
  background: ${({ selected, disabled }) => {
    if (disabled) return 'rgba(255,255,255,0.04)';
    return selected ? 'rgba(255, 116, 233, 0.3)' : 'rgba(255,255,255,0.08)';
  }};
  color: ${({ selected, disabled }) => {
    if (disabled) return 'rgba(255,255,255,0.3)';
    return selected ? '#fff' : 'rgba(255,255,255,0.7)';
  }};
  cursor: ${({ disabled }) => disabled ? 'not-allowed' : 'pointer'};
  transition: background 0.15s, color 0.15s;
  &:hover {
    background: ${({ selected, disabled }) => {
      if (disabled) return 'rgba(255,255,255,0.04)';
      return selected ? 'var(--primary-main, #a24bcf)' : 'rgba(255,255,255,0.18)';
    }};
    color: ${({ selected, disabled }) => {
      if (disabled) return 'rgba(255,255,255,0.3)';
      return selected ? '#fff' : '#fff';
    }};
  }
  @media only screen and (max-width: 600px) {
    padding: 6px 8px;
    font-size: 12px;
  }
`;

export const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 50px;
  min-height: 200px;
  @media only screen and (max-width: 600px) {
    padding: 40px 20px;
  }
`;

export const EmptyStateContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 50px;
  min-height: 200px;
  color: rgba(245, 225, 255, 0.6);
  text-align: center;
  @media only screen and (max-width: 600px) {
    padding: 40px 20px;
  }
`;

export const EmptyStateTitle = styled.div`
  font-size: 24px;
  font-family: Raleway;
  font-weight: 500;
  color: #fff;
`;

export const EmptyStateDescription = styled.div`
  font-size: 20px;
  font-family: Raleway;
  font-weight: 400;
  color: #fff;
`;

export const SearchTextField = styled(TextField)`
  .MuiOutlinedInput-root {
    color: #F5E1FF;
    background-color: #251A30;

    .MuiOutlinedInput-notchedOutline {
      border-color: #251A30;
    }

    &:hover .MuiOutlinedInput-notchedOutline {
      border-color: #FF74E9;
    }

    &.Mui-focused .MuiOutlinedInput-notchedOutline {
      border-color: #FF74E9;
    }

    .MuiInputAdornment-root {
      color: #F5E1FF80;
    }
  }
`;

export const ClearSearchButton = styled(IconButton)`
  color: #F5E1FF80;

  &:hover {
    color: #F5E1FF;
  }
`;

export const InstructionsContainer = styled.div`
  background: rgba(37, 26, 48, 1);
  border-radius: 12px;
  padding: 30px 60px;
  margin: 36px 0 16px 0;
  text-align: left;
  color: #f5e1ff;
  font-size: 18px;
  font-family: Raleway;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.1px;
`;

export const InstructionsList = styled.ol`
  margin: 0;
  padding-left: 0;
`;

export const JobsListContainer = styled.div`
  flex: 1 1 0%;
  overflow-y: auto;
  width: 100%;
  padding: 10px 30px 70px 30px;
  @media only screen and (max-width: 600px) {
    padding: 10px 0;
  }
`;
